import PropTypes from "prop-types"
import { MenuItem, TextField, Typography } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import { ESTADOS_DO_BRASIL, formatInputValuesToDefault } from "../../../../utils/financialHelper"
import EmptyElement from "../../../../components/Financial/CrudDialogForm/EmptyElement"
import { MaskedTextField } from "../../../../components/FormFields"
import CrudFormPage from "../../../../components/Financial/CrudFormPage";

const FormFornecedores = ({ values, setValues, isDelete: isDisabled, isLoadingSubmit = false }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: formatInputValuesToDefault(value) });
  }

  const tipoEntidade = ['Pessoa Física', 'Pessoa Jurídica']

  const ativo = [{ id: 1, name: 'Ativo' }, { id: 0, name: 'Inativo' }]

  return (
    <CrudFormPage isLoadingSubmit={isLoadingSubmit}>
      <div className='linha-campos'>
        <TextField
          label="Razão Social"
          id='companyName'
          name='companyName'
          value={values.companyName ?? ''}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          required
          fullWidth
          disabled={isDisabled}
        />
        <TextField
          label="Nome Fantasia"
          id='tradeName'
          name='tradeName'
          value={values.tradeName ?? ''}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          required
          fullWidth
          disabled={isDisabled}
        />
      </div>
      <div className='linha-campos'>
        <MaskedTextField
          mask={
            values?.cpfCnpj && values?.cpfCnpj?.replace(/[^\d]/g, '').length < 12
              ? '999.999.999-999'
              : '99.999.999/9999-99'
          }
          label="CPF/CNPJ"
          id='cpfCnpj'
          name='cpfCnpj'
          value={values.cpfCnpj ?? ''}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          varibleName='cpfCnpj'
          required
          fullWidth
          style={{ margin: '0' }}
          disabled={isDisabled}
        />
        <TextField
          label="Inscrição Estadual"
          id='stateRegistration'
          name='stateRegistration'
          value={values.stateRegistration ?? ''}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          fullWidth
          disabled={isDisabled}
        />
      </div>
      <div className='linha-campos'>
        <Autocomplete
          id="entityType"
          value={tipoEntidade.find(option => option === values.entityType)}
          options={tipoEntidade}
          renderInput={(params) => <TextField {...params} label="Tipo de Entidade" variant="outlined" InputLabelProps={{ shrink: true }} />}
          fullWidth
          disabled={isDisabled}
          onChange={(e, newValue) => setValues({ ...values, entityType: newValue })}
        />
        <EmptyElement />
      </div>

      <Typography variant="overline">Endereço</Typography>

      <div className='linha-campos'>
        <TextField
          label="Endereço"
          id='address'
          name='address'
          value={values.address ?? ''}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          fullWidth
          disabled={isDisabled}
        />
      </div>
      <div className='linha-campos'>
        <TextField
          label="Cidade"
          id='city'
          name='city'
          value={values.city ?? ''}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          fullWidth
          disabled={isDisabled}
        />
        <Autocomplete
          id="stateCode"
          value={ESTADOS_DO_BRASIL.find(option => option === values.stateCode)}
          options={ESTADOS_DO_BRASIL}
          renderInput={(params) => <TextField {...params} label="Estado" variant="outlined" InputLabelProps={{ shrink: true }} />}
          fullWidth
          disabled={isDisabled}
          onChange={(e, newValue) => { setValues({...values, stateCode: newValue})}}
        />
        <MaskedTextField
          mask='99.999-999'
          label="CEP"
          id='postalCode'
          name='postalCode'
          value={values.postalCode ?? ''}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          varibleName='postalCode'
          fullWidth
          style={{ margin: '0' }}
          disabled={isDisabled}
        />
      </div>

      <Typography variant="overline">Contato</Typography>

      <div className='linha-campos'>
        <TextField
          label="Pessoa de Contato"
          id='contactPerson'
          name='contactPerson'
          value={values.contactPerson ?? ''}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          fullWidth
          disabled={isDisabled}
        />
        <TextField
          label="Telefone"
          id='phone'
          name='phone'
          value={values.phone ?? ''}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          fullWidth
          disabled={isDisabled}
        />
        <TextField
          label="E-mail"
          id='email'
          name='email'
          value={values.email ?? ''}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          fullWidth
          disabled={isDisabled}
        />
      </div>

      <Typography variant="overline">Observações</Typography>

      <div className='linha-campos'>
        <TextField
          label="Serviços Prestados"
          id='providedServices'
          name='providedServices'
          value={values.providedServices ?? ''}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          fullWidth
          disabled={isDisabled}
        />
      </div>
      <div className='linha-campos'>
        <TextField
          label="Notas"
          id='notes'
          name='notes'
          value={values.notes ?? ''}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
          fullWidth
          disabled={isDisabled}
        />
      </div>
      <div className='linha-campos'>
        <Autocomplete
          id="isActive"
          options={ativo}
          getOptionLabel={(option) => option.name}
          value={ativo.find(option => option.id === values.isActive)}
          renderInput={(params) => <TextField {...params} label="Ativo" variant="outlined" InputLabelProps={{ shrink: true }} />}
          onChange={(e, newValue) => { setValues({...values, isActive: newValue?.id})}}
          fullWidth
          disabled={isDisabled}
        />

        <EmptyElement />
        <EmptyElement />
        <EmptyElement />
        <EmptyElement />
      </div>

    </CrudFormPage>
  )
}

FormFornecedores.propTypes = {
  values: PropTypes.shape({
    id: PropTypes.number,
    companyName: PropTypes.string,
    tradeName: PropTypes.string,
    cpfCnpj: PropTypes.string,
    entityType: PropTypes.oneOf(['Pessoa Física', 'Pessoa Jurídica']),
    stateRegistration: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    address: PropTypes.string,
    city: PropTypes.string,
    stateCode: PropTypes.string,
    postalCode: PropTypes.string,
    contactPerson: PropTypes.string,
    providedServices: PropTypes.string,
    isActive: PropTypes.number,
    notes: PropTypes.string,
  }).isRequired,
  setValues: PropTypes.func.isRequired,
  isDelete: PropTypes.bool.isRequired,
  isLoadingSubmit: PropTypes.bool.isRequired,
}

export default FormFornecedores